//
// Copyright 2023 DXOS.org
//

// TODO(wittjosiah): Consider mapping console processor directly to browser processor in the browser.
export const CONSOLE_PROCESSOR = () => {};
